// extracted by mini-css-extract-plugin
export default {"root":"ValidationTimeMaskInput_root__AIdJi","errorMessage":"ValidationTimeMaskInput_errorMessage__RI9Un"};